export const DATASOURCE_TYPE = 'gmaps-location';
